const trialBrandColors = {
	gradientEnd: "#3F4948",
	gradientStart: "#5C8560",
	spring: "#A1DBA6",
	textFaint: "#B8C8B9",
	textMuted: "#D4E0D5",
	textPrimary: "#EAF1EA",
	textSoft: "#E6EFE6"
} as const;

declare module "@mui/material/styles" {
	interface Palette {
		trialBrand: typeof trialBrandColors;
	}

	interface PaletteOptions {
		trialBrand?: typeof trialBrandColors;
	}
}

export default trialBrandColors;
